import { FC, ReactNode } from 'react';
import { Stack, StackItem, StackProps } from '@optimus-web/core';

interface DescriptionItemProps extends Omit<StackProps, 'children'> {
    term: ReactNode;
    definition: ReactNode;
    definitionHighlighted?: boolean;
    termHighlighted?: boolean;
    stretchDefinition?: boolean;
}

export const DescriptionItem: FC<DescriptionItemProps> = ({
    term,
    definition,
    termHighlighted,
    definitionHighlighted,
    stretchDefinition,
    ...other
}) => (
    <Stack spacing="0" distribution="stretch" wrap {...other}>
        <StackItem width="40%" maxWidth="40%" padding="25" data-test-id="term">
            {termHighlighted ? <strong>{term}</strong> : term}
        </StackItem>
        <StackItem width={stretchDefinition ? '100%' : '60%'} padding="25" data-test-id="definition">
            {definitionHighlighted ? <strong>{definition}</strong> : definition}
        </StackItem>
    </Stack>
);
